import React from "react";

//component ================  
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";

import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Table from "components/Table/Table.jsx";
import Checkbox from "@material-ui/core/Checkbox";

import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import TextField from '@material-ui/core/TextField';
import CardIcon from "components/Card/CardIcon" 
import CardHeader from "components/Card/CardHeader"

import { compose } from "recompose"
import { connect } from "react-redux"
import { updateAnswers } from "store/actions"
import { replaceNumberQuestion } from "helpers/ConvertString"

//icon ============
import Check from "@material-ui/icons/Check";
import FiberManualRecord from "@material-ui/icons/FiberManualRecord";

import withStyles from "@material-ui/core/styles/withStyles";

// import loginPageStyle from "assets/jss/material-dashboard-pro-react/views/loginPageStyle.jsx";
import regularFormsStyle from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle.jsx";

class QRadioComponent extends React.Component {
    constructor(props) {
      super(props)
      this.state = {  
        countUpdate:0,
        headerLabel:this.props.headerLabel, 
        language:this.props.language, 
        dataQuestion:this.props.dataQuestion, 
        sectionName:this.props.sectionName, 
        questionName:this.props.questionName,
        value:this.props.value, 
      }
    }  
    handleChangeRadioEnabled(choosed,comment) { 
      var answers = {}; 
      answers = choosed
      if(comment){
        answers.comment = comment
      }
      answers.type = this.state.dataQuestion.type
      answers = choosed
      this.setState({
        answers:answers
      },()=>{
        this.props.updateAnswersCallback(this.state.sectionName,this.state.questionName,answers,()=>{ 
          this.setState({countUpdate:++this.state.countUpdate})
        })
       
      })
    }; 
    renderQuestion(){
      const date = this.state.dataQuestion  
      return (
        <div> 
          <div className="redio-question m-b-2">
            {
              !this.props.hideNumberQuestion?
                <span className="m-r-2 W100">
                  {replaceNumberQuestion(this.state.questionName) +") "}
                </span> 
              :""
            } 
            {date[this.state.language]["question"+(this.props.isScriptAgent?"_agent":"")]}
          </div> 
          <GridContainer className="m-l-4"> 
                {this.renderAnswers(date[this.state.language].answer)}
          </GridContainer>
        </div>
      ) 
    }
    renderAnswers(Cdata){
      return Cdata.map((data,index)=>{
        var checked = false 
        if(this.state.value[this.state.sectionName] && this.state.value[this.state.sectionName][this.state.questionName]){ 
          checked = this.state.value[this.state.sectionName][this.state.questionName].value === data.value
        } 
        return ( 
          <GridItem xs={"auto"} key={"answers_" + this.state.questionName + "_" + index}>
            <FormControlLabel 
              control={
                <Radio
                checked={checked} 
                onChange={(e)=>this.handleChangeRadioEnabled(data)} 
                icon={
                  <FiberManualRecord
                    className={this.props.classes.radioUnchecked}
                  />
                }
                checkedIcon={
                  <FiberManualRecord
                    className={this.props.classes.radioChecked}
                  />
                }
                classes={{
                  checked: this.props.classes.radio
                }} 
              />}
              classes={{
                label: this.props.classes.label
              }} 
              label={<div className={"wp p-r-2 txt-c-b2"}>{(data.showRemark)?this.renderRemark(data,checked):data.name}</div>}
            /> 
          </GridItem>
        )
      })
    }
    renderRemark(data,checked){
      return (
          <TextField
            value={(this.state.value && this.state.value[this.state.sectionName] && this.state.value[this.state.sectionName][this.state.questionName] && this.state.value[this.state.sectionName][this.state.questionName].comment)?this.state.value[this.state.sectionName][this.state.questionName].comment:""} 
            onChange={(e)=>this.handleChangeRadioEnabled(data,e.target.value)} 
            disabled={!checked}
            id="outlined-dense"
            label={data.name}
            className={"W50vw"}
            margin="dense"
            variant="outlined"
            fullWidth
          />
      )
    }
    render() { 
      return (     
        <Card className={(this.props.isAlphaBGMode)?"isAlphaMode":"card-bg-90"}>
          {
            (this.state.headerLabel)?
            <CardHeader color="info" icon>
              <CardIcon color="danger" className="icon-question">
                <span className="title-question">{this.state.headerLabel}</span>
              </CardIcon> 
            </CardHeader>
            :""
          } 
          <CardContent> 
          {
            this.renderQuestion()
          } 
          </CardContent>  
        </Card> 
      );
    }
} 
function mapStateToProps({ answers }) { 
  return {
    answers: answers
  }
}

export default compose(
  withStyles(regularFormsStyle),
  connect(
    mapStateToProps,
    { updateAnswers }
  )
)(QRadioComponent)